import React from 'react';
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from 'react-router-dom';
import { defaultRedirect, ALL_ROLES } from 'constants/roles';
import { UnauthorizedPage } from 'views/unauthorized';
import { ExceptionManagementRouting } from './exception-management/ExceptionManagementRouting';
import { AdministrationRouting } from './administration/AdministrationRouting';
import { JobCostingRouting } from './job-costing/JobCostingRouting';
import VatPartnersEdit from './vat-partners-edit/VatPartnersEdit';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import * as mainRoutes from 'constants/routes';
import { IRoles } from 'utilities/roles';
import { LoadingAnimation } from 'components/loading';
import { CustomerBillingRouting } from './customer-billing/CustomerBillingRouting';
import { CONFIG } from 'configs/index';
import { includesPartialString } from 'utilities/util';
import EditBillToPartyAndVatPartner from './EditBillToPartyAndVatPartner/EditBillToPartyAndVatPartner';

interface IMapStateToProps {
    roles: IRoles[];
    rolesAreLoading: boolean;
};
interface IProps extends IMapStateToProps, RouteComponentProps<{}> { };
interface IState {
    redirectPath: string;
    datadogInit: boolean;
}
export class _RoutingConfiguration extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props)
        this.state = {
            redirectPath: '',
            datadogInit: false
        }
    }
    public componentDidMount() {
        this.init()
    }
    public componentDidUpdate(props: any) {
        if (this.props.rolesAreLoading !== props.rolesAreLoading || this.props.roles !== props.roles) {
            this.checkRoles()
        }
    }
    public init = () => {
        if (!this.state.datadogInit) {
            if (CONFIG.Type === 'prod' || CONFIG.Type === 'preprod' || CONFIG.Type === 'test') {
                const walkme = document.createElement('script');
                walkme.type = 'text/javascript';
                walkme.async = true;
                walkme.src = CONFIG.walkMe;
                const s = document.getElementsByTagName('script')[0] as any;
                s.parentNode.insertBefore(walkme, s);
                const _thisWindow: any = window;
                _thisWindow._walkmeConfig = { smartLoad: true };
            }
            this.setState({ datadogInit: true });
        }
        this.checkRoles()
    }
    public checkRoles = () => {
        if (!this.props.rolesAreLoading && Array.isArray(this.props.roles) && this.props.roles.length > 0 && this.props.roles[0] as any !== 'No permissions') {
            for (const role of this.props.roles) {
                if (ALL_ROLES.some(bf => bf === role.name || bf === role.Name)) {
                    const businessFunction = role.name || role.Name as string;
                    const url: any = sessionStorage.getItem('msal.login.request')
                    if (url &&
                        url.replace(location.origin, '') !== '/' &&
                        includesPartialString(url.replace(location.origin, ''), mainRoutes.MAIN_ROUTES)) {
                        this.setState({ redirectPath: url.replace(location.origin, '') });
                    } else {
                        this.setState({ redirectPath: (defaultRedirect[businessFunction]) });
                    }
                    break;
                } else {
                    this.setState({ redirectPath: (mainRoutes.OTHER_ROUTES.UNAUTHORIZED) });
                }
            }
        } else if (!this.props.rolesAreLoading && this.props.roles.length > 0 && this.props.roles[0] as any === 'No permissions') {
            this.props.history.replace(mainRoutes.OTHER_ROUTES.UNAUTHORIZED)
        }
    }
    public render() {
        if (this.props.rolesAreLoading) {
            return <LoadingAnimation />;
        } else {
            return (
                <React.Fragment>
                    {this.props.roles && <Switch>
                        <Route path="/job-costing" component={JobCostingRouting} />
                        <Route path="/customer-billing" component={CustomerBillingRouting} />
                        <Route path="/exception-management" component={ExceptionManagementRouting} />
                        <Route path="/unauthorized" component={UnauthorizedPage} />
                        <Route path="/administration" component={AdministrationRouting} />
                        <Route path="/vat-partners-edit" component={VatPartnersEdit} />
                        <Route path="/edit-bill-to-party-and-vat-partner" component={EditBillToPartyAndVatPartner} />
                        <Redirect to={this.state.redirectPath} />
                    </Switch>}
                </React.Fragment>
            )
        }
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    roles: state.user.roles,
    rolesAreLoading: state.user.rolesAreLoading
});

export const RoutingConfiguration = withRouter(connect<IMapStateToProps, {}, IStore>(mapStateToProps)(_RoutingConfiguration));
